var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilterIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 11.899V5.5757L0.666992 1.90904V0.0957031H11.3337V1.90904L7.33366 5.5757V9.23237L4.66699 11.899ZM1.33366 1.6157L5.33366 5.28237V10.2924L6.66699 8.95904V5.28237L10.667 1.6157V0.76237H1.33366V1.6157Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilterIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Filter_Icon.eb7ded0f58f1af9a662ba2e133522a17.svg";